const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export async function sendContactEmail(data: ContactFormData) {
  const url = `${API_BASE_URL}/api/send-email.php`;

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const responseData = await res.json();

  if (!res.ok || !responseData.success) {
    throw new Error(responseData.error || 'Failed to send message');
  }

  return responseData;
}
